import EventHandler from '../../utils/dom/event-handler';
import SelectorEngine from '../../utils/dom/selector-engine';
import Modal from '../../components/Modal';
import Request, { ApiMode } from '../../utils/request';

const SELECTOR_WRAPPER = '.p-school-portal-voucher';
const SELECTOR_MODAL = '.js-school-portal-modal';

const SELECTOR_BUTTON_SUPPORT = '.js-school-portal-support';
const SELECTOR_BUTTON_EQUIPMENT = '.js-school-portal-equipment';
const SELECTOR_BUTTON_MODAL_STAY = '.lta-checkout-modal-stay';
const SELECTOR_BUTTON_MODAL_LEAVE = '.lta-checkout-modal-leave';

const SELECTOR_MODAL_TITLE = '.p-school-portal-voucher_modaltitle';
const SELECTOR_SUPPORT = '.p-school-portal-voucher--support';
const SELECTOR_EQUIPMENT = '.p-school-portal-voucher--equipment';

const SELECTOR_SUPPORT_REDEEM = '.p-school-portal-voucher--support-redeem';
const SELECTOR_EQUIPMENT_REDEEM = '.p-school-portal-voucher--equipment-redeem';

const SELECTOR_COPY_CODE = '.p-school-portal-voucher--equipment-redeem-copy-code';

const SELECTOR_SUPPORT_CONFIRM = '.p-school-portal-voucher--support-redeem-confirm';
const SELECTOR_EQUIPMENT_CONFIRM = '.p-school-portal-voucher--equipment-redeem-confirm';

const SELECTOR_SUPPORT_AFTER_CONFIRM = '.p-school-portal-voucher--support-redeem-after';
const SELECTOR_EQUIPMENT_AFTER_CONFIRM = '.p-school-portal-voucher--equipment-redeem-after';

const SELECTOR_VOUCHER_INPUT = '.p-school-portal-voucher__input';
const SELECTOR_UNIQUE_CODE = '.discount-code-input';

const SUPPORT_TITLE_MESSAGE = 'YOU WANT CLUB LINK SUPPORT?';
const EQUIPMENT_TITLE_MESSAGE = 'YOU WANT TENNIS EQUIPMENT?';

const CLICK_EVENT = 'click';
const HIDDEN_CLASS = 'u-hidden';

const FROM_SUPPORT = 'is-from-support';
const FROM_EQUIPMENT = 'is-from-equipment';

const IS_LOCAL = false;
class SchoolVoucher {
	constructor() {
		this._wrapper = SelectorEngine.findOne(SELECTOR_WRAPPER);
		if (!this._wrapper) {
			return;
		}
		this.init();
	}

	init() {
		this.supportButton = SelectorEngine.findOne(SELECTOR_BUTTON_SUPPORT, this._wrapper);
		this.equipmentButton = SelectorEngine.findOne(SELECTOR_BUTTON_EQUIPMENT, this._wrapper);
		this.modalElement = SelectorEngine.findOne(SELECTOR_MODAL, this._wrapper);

		this.supportSelector = SelectorEngine.findOne(SELECTOR_SUPPORT, this._wrapper);
		this.equipmentSelector = SelectorEngine.findOne(SELECTOR_EQUIPMENT, this._wrapper);

		this.supportRedeemSelector = SelectorEngine.findOne(SELECTOR_SUPPORT_REDEEM, this.supportSelector);
		this.supportConfirm = SelectorEngine.findOne(SELECTOR_SUPPORT_CONFIRM, this.supportSelector);
		this.supportAfterConfirm = SelectorEngine.findOne(SELECTOR_SUPPORT_AFTER_CONFIRM, this.supportSelector);
		
		this.equipmentRedeemSelector = SelectorEngine.findOne(SELECTOR_EQUIPMENT_REDEEM, this.equipmentSelector);
		this.equipmentConfirm = SelectorEngine.findOne(SELECTOR_EQUIPMENT_CONFIRM, this.equipmentSelector);
		this.equipmentConfirmAfter = SelectorEngine.findOne(SELECTOR_EQUIPMENT_AFTER_CONFIRM, this.equipmentSelector);
		this.equipmentCopyCodeButton = SelectorEngine.findOne(SELECTOR_COPY_CODE, this.equipmentSelector);

		this.modalTitleElement = SelectorEngine.findOne(SELECTOR_MODAL_TITLE, this.modalElement);
		this.modalStayButton = SelectorEngine.findOne(SELECTOR_BUTTON_MODAL_STAY, this.modalElement);
		this.modalLeaveButton = SelectorEngine.findOne(SELECTOR_BUTTON_MODAL_LEAVE, this.modalElement);
		this.voucherIdWrapper = SelectorEngine.findOne(SELECTOR_VOUCHER_INPUT, this._wrapper);
		this.voucherInput = SelectorEngine.findOne('input', this.voucherIdWrapper);
		this.uniqueCodeInput = SelectorEngine.findOne('input', this.equipmentSelector);

		this.voucherModal = new Modal(this.modalElement, { backdrop: 'static'});
		
		EventHandler.on(this.supportButton, CLICK_EVENT, () => {
			this.modalTitleElement.innerHTML = SUPPORT_TITLE_MESSAGE;
			this.voucherModal.presentForm = FROM_SUPPORT;
			this.voucherModal.show();
		});

		EventHandler.on(this.equipmentButton, CLICK_EVENT, () => {
			this.modalTitleElement.innerHTML = EQUIPMENT_TITLE_MESSAGE;
			this.voucherModal.presentForm = FROM_EQUIPMENT;
			this.voucherModal.show();
		});

		EventHandler.on(this.equipmentCopyCodeButton, CLICK_EVENT, () => {
			navigator.clipboard.writeText(this.uniqueCodeInput.value);
		});

		EventHandler.on(this.modalStayButton, CLICK_EVENT, () => {
			this.voucherModal.hide();
		});

		EventHandler.on(this.modalLeaveButton, CLICK_EVENT, () => {
			this.voucherModal.hide();
			const voucherType = this.voucherModal.presentForm === FROM_SUPPORT ? 'Coaching' : 'Equipment';
			this.redeemVoucher(this.voucherInput.value, voucherType);
		});
	}
	voucherRedeemSuccess() {
		if(this.voucherModal.presentForm === FROM_SUPPORT) {
			this.supportButton.classList.add(HIDDEN_CLASS);
			this.supportRedeemSelector.classList.remove(HIDDEN_CLASS);

			this.equipmentButton.classList.add(HIDDEN_CLASS);
			this.equipmentConfirm.classList.add(HIDDEN_CLASS);
			this.equipmentRedeemSelector.classList.remove(HIDDEN_CLASS);
			this.equipmentConfirmAfter.classList.remove(HIDDEN_CLASS);
		}
		if(this.voucherModal.presentForm === FROM_EQUIPMENT) {
			this.equipmentButton.classList.add(HIDDEN_CLASS);
			this.equipmentRedeemSelector.classList.remove(HIDDEN_CLASS);

			this.supportButton.classList.add(HIDDEN_CLASS);
			this.supportConfirm.classList.add(HIDDEN_CLASS);
			this.supportRedeemSelector.classList.remove(HIDDEN_CLASS);
			this.supportAfterConfirm.classList.remove(HIDDEN_CLASS);
		}
	}
	async redeemVoucher(voucherIdValue, voucherTypeValue) {
		const dataObject = {
			voucherId: voucherIdValue,
			voucherType: voucherTypeValue
		};
		try {
			const url = `/api/schoolvoucher/Claim-voucher`;
			const responseData = await Request.post(url, dataObject, {
				local: IS_LOCAL,
				req: {
					apiMode: ApiMode.LtaError
			 }
			});
			const { success, voucherCode, voucherType, error } = responseData;
			if (success) {
				this.voucherRedeemSuccess();
				this.uniqueCodeInput.value = voucherCode;
			}

			if (!!error?.hasError) {
				throw error;
			}
		} catch (error) {
			if (error.hasError) {
				console.log("Error : ", error);
			}
		}
	}
}

const globalSchoolVoucher = new SchoolVoucher();
export default globalSchoolVoucher;
